var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container cardResgate" },
    [
      _c(
        "div",
        { staticClass: "flex-between gap-2" },
        [
          _c("HeaderVoltar", {
            attrs: {
              label: "Novo cadastro",
              pageBack: "listagem/praticas",
              hasProcesso: _vm.hasProcesso
            }
          }),
          _vm._v(" "),
          _c("Alert", {
            attrs: {
              type: "info",
              title: "Atenção!",
              description:
                "Ao cadastrar as práticas sustentáveis,\n      considere o conjunto da área que compõe o imóvel como um todo,\n      mesmo que ela esteja vinculada a mais de um CAR.",
              colapsedMode: true
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("CardBase", {
        scopedSlots: _vm._u([
          {
            key: "info-card",
            fn: function() {
              return [
                _c("cadastro-sicarf", {
                  ref: "cadastroSicarf",
                  attrs: {
                    titleCadastro: "Cadastro de práticas",
                    routeName: "praticas",
                    cadastroEmpty: _vm.empty,
                    tabs: _vm.tabsFiltradas,
                    tipoCadastro: _vm.tipoCadastro
                  },
                  on: { "has-processo-changed": _vm.atualizarHasProcesso }
                })
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-71b15294", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71b15294","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App/(authenticated)/modulos/cadastro/formulario-cadastro/cadastro.vue
// module id = null
// module chunks = 